import AddButtonStoreManager from '../../../customized/fresh-watch/components/StoreManager/AddButtonStoreManager';
import { ToggleComponent } from '../../../featureToggle';
import AddButtonDeviceManager from './AddButtonDeviceManager';

export * from './AddButtonDeviceManager';

export default ToggleComponent(AddButtonDeviceManager, {
  styledComponentsVariants: {
    'fresh-watch': AddButtonStoreManager,
  },
});
